import { render, staticRenderFns } from "./ImageWithZoom.vue?vue&type=template&id=b79dded8"
import script from "./ImageWithZoom.vue?vue&type=script&lang=js"
export * from "./ImageWithZoom.vue?vue&type=script&lang=js"
import style0 from "./ImageWithZoom.vue?vue&type=style&index=0&id=b79dded8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports